import DistributionCentersConfig from './table/configs/distributionCentersConfig.json';
import InventoriesConfig from './table/configs/inventories.json';
import LogsConfig from './repair-details/logs/repairLogsConfig.json';
import MaintenanceOrdersConfig from './table/configs/maintenanceOrdersConfig.json';
import OrderDetailsConfig from './table/configs/purchase_order_details.json';
import AccessoryLoadingOrdersConfig from './table/configs/accessoryLoadingOrders.json';
import PromoConfig from './table/configs/promoConfig.json';
import PurchaseOrdersConfig from './table/configs/purchaseOrders.json';
import RefrigeratorsConfig from './table/configs/refrigerators.json';
import RepairOrdersConfig from './table/configs/repair_orders.json';
import RepresentativesConfig from './table/configs/reprsentatives.json';
import ReturnCommands from './table/configs/returnCommands.json';
import SapLogsConfig from './table/configs/sapLogs.json';
import UsersConfig from './table/configs/users.json';
import recycleCommandsConfig from './table/configs/recycleCommands.json';
import refrigeratorTransfersConfig from './table/configs/refrigerator-transfers.json';
import saleCommandsConfig from './table/configs/saleCommands.json';
import withdrawalCommandsConfig from './table/configs/withdrawalCommands.json';
import {AdminGuardService} from './services/admin-guard.service';
import {AgreementDetailsComponent} from './agreements/agreement-details/agreement-details.component';
import {AgreementsComponent} from './agreements/agreements.component';
import {AuthGuardService} from './services/auth-guard.service';
import {DistributionLocationsLimitsComponent} from './distribution-locations-limits/distribution-locations-limits.component';
import {ErrorComponent} from './error/error.component';
import {EvaluatedRefrigeratorDetailsComponent} from './evaluation/evaluated-refrigerator-details/evaluated-refrigerator-details.component';
import {EvaluationComponent} from './evaluation/evaluation.component';
import {HelpComponent} from './help/help.component';
import {HomeComponent} from './home/home.component';
import {InventoriesGuardService} from './services/inventories-guard.service';
import {InventoryDetailsComponent} from './inventory-details/inventory-details.component';
import {LoadingOrderDetailsComponent} from './loading-orders/loading-order-details/loading-order-details.component';
import {LoadingOrderDetailsInfoComponent} from './loading-orders/loading-order-details-info/loading-order-details-info.component';
import {LoadingOrdersComponent} from './loading-orders/loading-orders.component';
import {LoginComponent} from './login/login.component';
import {MainGuardService} from './services/main-guard.service';
import {MainNavComponent} from './main-nav/main-nav.component';
import {MaintenanceFormComponent} from './maintenance-form/maintenance-form.component';
import {NgModule} from '@angular/core';
import {NotificationsComponent} from './notifications/notifications.component';
import {OrderDetailsComponent} from './order-details/order-details.component';
import {PdfSampleComponent} from './pdf-sample/pdf-sample.component';
import {PromoDetailsComponent} from './promo-details/promo-details.component';
import {PurchaseOrdersGuardService} from './services/purchase-orders-guard.service';
import {QuestionairesComponent} from './questionaires/questionaires.component';
import {QuestionnaireCreatorComponent} from './questionaires/questionnaire-creator/questionnaire-creator.component';
import {QuestionnaireDetailsComponent} from './questionaires/questionnaire-details/questionnaire-details.component';
import {ReceiptOrdersComponent} from './receipt-orders/receipt-orders.component';
import {ReceivingOrderDetailsComponent} from './receipt-orders/receiving-order-details/receiving-order-details.component';
import {ReceivingOrderDetailsInfoComponent} from './receipt-orders/receiving-order-details-info/receiving-order-details-info.component';
import {RecycleDetailsComponent} from './recycle-details/recycle-details.component';
import {RecycleSaleGuardService} from './services/recycle-sale-guard.service';
import {RedistributionDialogComponent} from './super-market-budget/components/budget/redistribution-dialog/redistribution-dialog.component';
import {RefrigeratorBudgetComponent} from './refrigerator-budget/refrigerator-budget.component';
import {RefrigeratorDetailsComponent} from './refrigerator-details/refrigerator-details.component';
import {RefrigeratorOldBudgetComponent} from './budget/refrigerator-old-budget/refrigerator-old-budget.component';
import {RefrigeratorTransfersGuardService} from './services/refrigerator-transfers-guard.service';
import {RepairDetailsComponent} from './repair-details/repair-details.component';
import {RepairOrderFormComponent} from './repair-order-form/repair-order-form.component';
import {RepairsGuardService} from './services/repairs-guard.service';
import {RequestOrderDetailsComponent} from './request-order-details/request-order-details.component';
import {ReturnRefrigeratorDetailsComponent} from './return-refrigerator-details/return-refrigerator-details.component';
import {Routes, RouterModule} from '@angular/router';
import {SaleDetailsComponent} from './sale-details/sale-details.component';
import {SalePointComponent} from './sale-point/sale-point.component';
import {SalePointDetailsComponent} from './sale-point-details/sale-point-details.component';
import {SalePointVersionDetailsComponent} from './sale-point-version-details/sale-point-version-details.component';
import {SalePointsGuardService} from './services/sale-points-guard.service';
import {SettingsComponent} from './settings/settings.component';
import {StatisticsComponent} from './statistics/statistics.component';
import {SuperMarketBudgetComponent} from './super-market-budget/super-market-budget.component';
import {TableComponent} from './table/table.component';
import {UserDetailsComponent} from './users/user-details/user-details.component';
import {UserFormComponent} from './users/user-form/user-form.component';
import {WithdrawalDetailsComponent} from './withdrawal-details/withdrawal-details.component';
import {
  RefrigeratorTransferDetailsComponent
} from './refrigerator-transfer-details/refrigerator-transfer-details.component';
import {
  RouteTransferFormComponent
} from './refrigerator-transfers/components/route-transfer-form/route-transfer-form.component';
import {RefrigeratorTransfersComponent} from './refrigerator-transfers/refrigerator-transfers.component';
import {RequestOrderComponent} from './request-order/request-order.component';
import {AccessoryRequestDetailsComponent} from './accessory-request-details/accessory-request-details.component';
import {
  AccessoryLoadingOrderDetailsComponent
} from "./accessory-loading-order-details/accessory-loading-order-details.component";

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    canActivate: [AuthGuardService],
    component: LoginComponent
  },
  {
    path: '',
    component: MainNavComponent,
    canActivateChild: [MainGuardService],
    children: [
      {
        path: 'home',
        component: HomeComponent
      },
      {
        path: 'agreements',
        component: AgreementsComponent
      },
      {
        path: 'agreement-details/:id',
        component: AgreementDetailsComponent
      },
      {
        path: 'help',
        component: HelpComponent
      },
      {
        path: 'me',
        component: UserDetailsComponent
      },
      {
        path: 'user-form',
        canActivate: [AdminGuardService],
        component: UserFormComponent
      },
      {
        path: 'inventory/:id',
        canActivate: [InventoriesGuardService],
        component: InventoryDetailsComponent
      },
      {
        path: 'refrigerator/:id',
        component: RefrigeratorDetailsComponent
      },
      {
        path: 'sale-point/:id',
        canActivate: [SalePointsGuardService],
        component: SalePointDetailsComponent
      },
      {
        path: 'sale-point-version/:id',
        canActivate: [SalePointsGuardService],
        component: SalePointVersionDetailsComponent
      },
      {
        path: 'user/:id',
        canActivate: [AdminGuardService],
        component: UserDetailsComponent
      },
      {
        path: 'inventories',
        canActivate: [InventoriesGuardService],
        component: TableComponent,
        data: {config: InventoriesConfig}
      },
      {
        path: 'loading_orders',
        canActivate: [PurchaseOrdersGuardService],
        component: LoadingOrdersComponent
      },
      {
        path: 'loading_order_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: LoadingOrderDetailsComponent
      },
      {
        path: 'loading_order_details_info/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: LoadingOrderDetailsInfoComponent
      },
      {
        path: 'receipt_orders',
        canActivate: [PurchaseOrdersGuardService],
        component: ReceiptOrdersComponent
      },
      {
        path: 'questionaires',
        component: QuestionairesComponent
      },
      {
        path: 'questionnaire_details/:id',
        component: QuestionnaireDetailsComponent
      },
      {
        path: 'questionnaire-creator',
        component: QuestionnaireCreatorComponent
      },
      {
        path: 'receiving_order_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: ReceivingOrderDetailsComponent
      },
      {
        path: 'receiving_order_details_info/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: ReceivingOrderDetailsInfoComponent
      },
      {
        path: 'purchase_orders',
        canActivate: [PurchaseOrdersGuardService],
        component: TableComponent,
        data: {config: PurchaseOrdersConfig}
      },
      {
        path: 'order_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: OrderDetailsComponent,
        data: {config: OrderDetailsConfig}
      },
      {
        path: 'statistics',
        canActivate: [PurchaseOrdersGuardService],
        component: StatisticsComponent
      },
      {
        path: 'sale',
        canActivate: [],
        component: TableComponent,
        data: {config: saleCommandsConfig}
      },
      {
        path: 'sale_details/:id',
        canActivate: [RecycleSaleGuardService],
        component: SaleDetailsComponent
      },
      {
        path: 'pdfSample/:id',
        component: PdfSampleComponent
      },
      {
        path: 'purchase_order_requests',
        canActivate: [PurchaseOrdersGuardService],
        component: RequestOrderComponent
      },
      {
        path: 'accessory_request_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: AccessoryRequestDetailsComponent
      },
      {
        path: 'accessory_loading_command_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: AccessoryLoadingOrderDetailsComponent
      },
      {
        path: 'accessory_loading_commands',
        canActivate: [PurchaseOrdersGuardService],
        component: TableComponent,
        data: {config: AccessoryLoadingOrdersConfig}
      },
      {
        path: 'returns',
        canActivate: [PurchaseOrdersGuardService],
        component: TableComponent,
        data: {config: ReturnCommands}
      },
      {
        path: 'return_refrigerator_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: ReturnRefrigeratorDetailsComponent,
      },
      {
        path: 'request_order_details/:id',
        canActivate: [PurchaseOrdersGuardService],
        component: RequestOrderDetailsComponent,
      },
      {
        path: 'repairs',
        component: TableComponent,
        canActivate: [RepairsGuardService],
        data: {config: RepairOrdersConfig}
      },
      {
        path: 'refrigerator_transfers',
        component: RefrigeratorTransfersComponent,
        canActivate: [RefrigeratorTransfersGuardService],
        data: {config: refrigeratorTransfersConfig}
      },
      {
        path: 'refrigerator_transfer/:id',
        component: RefrigeratorTransferDetailsComponent,
        canActivate: [RefrigeratorTransfersGuardService]
      },
      {
        path: 'maintenance',
        canActivate: [RepairsGuardService],
        component: TableComponent,
        data: {config: MaintenanceOrdersConfig}
      },
      {
        path: 'repair_details/:id',
        canActivate: [RepairsGuardService],
        component: RepairDetailsComponent,
      },
      {
        path: 'repair-form',
        canActivate: [RepairsGuardService],
        component: RepairOrderFormComponent,
      },
      {
        path: 'maintenance-form',
        canActivate: [RepairsGuardService],
        component: MaintenanceFormComponent,
      },
      {
        path: 'notifications',
        canActivate: [AdminGuardService],
        component: NotificationsComponent
      },
      {
        path: 'sap_logs',
        canActivate: [AdminGuardService],
        component: TableComponent,
        data: { config: SapLogsConfig}
      },
      {
        path: 'refrigerators',
        component: TableComponent,
        data: {config: RefrigeratorsConfig}
      },
      {
        path: 'sale-points',
        canActivate: [SalePointsGuardService],
        component: SalePointComponent
      },
      {
        path: 'representatives',
        canActivate: [SalePointsGuardService],
        component: TableComponent,
        data: {config: RepresentativesConfig}
      },
      {
        path: 'distributionCenters',
        canActivate: [SalePointsGuardService],
        component: TableComponent,
        data: {config: DistributionCentersConfig}
      },
      {
        path: 'refrigerator-budget',
        canActivate: [PurchaseOrdersGuardService],
        component: RefrigeratorBudgetComponent
      },
      {
        path: 'refrigerator-old-budget',
        canActivate: [PurchaseOrdersGuardService],
        component: RefrigeratorOldBudgetComponent
      },
      {
        path: 'super-market-budget',
        canActivate: [PurchaseOrdersGuardService],
        component: SuperMarketBudgetComponent
      },
      {
        path: 'redistribution-form',
        canActivate: [PurchaseOrdersGuardService],
        component: RedistributionDialogComponent
      },
      {
        path: 'route-transfer-form',
        canActivate: [RefrigeratorTransfersGuardService],
        component: RouteTransferFormComponent
      },
      {
        path: 'distribution-limits',
        canActivate: [PurchaseOrdersGuardService],
        component: DistributionLocationsLimitsComponent
      },
      {
        path: 'promo',
        component: TableComponent,
        data: {config: PromoConfig}
      },
      // {
      //   path: 'promoDetails/:id',
      //   component: TableComponent,
      //   data: { config: PromoDetailsConfig }
      // },
      {
        path: 'promoDetails/:id',
        component: PromoDetailsComponent,
      },

      {
        path: 'settings',
        canActivate: [AdminGuardService],
        component: SettingsComponent
      },
      {
        path: 'evaluation',
        canActivate: [AdminGuardService],
        component: EvaluationComponent
      },
      {
        path: 'evaluated_refrigerator_details/:id',
        canActivate: [AdminGuardService],
        component: EvaluatedRefrigeratorDetailsComponent
      },
      {
        path: 'logs',
        canActivate: [PurchaseOrdersGuardService],
        component: TableComponent,
        data: {config: LogsConfig}
      },
      {
        path: 'users',
        canActivate: [AdminGuardService],
        component: TableComponent,
        data: {config: UsersConfig}
      },
      {
        path: 'withdrawal',
        canActivate: [],
        component: TableComponent,
        data: {config: withdrawalCommandsConfig}
      },
      {
        path: 'withdrawal_details/:id',
        canActivate: [],
        component: WithdrawalDetailsComponent,
      },
      {
        path: 'recycle',
        canActivate: [],
        component: TableComponent,
        data: {config: recycleCommandsConfig}
      },
      {
        path: 'recycle_details/:id',
        canActivate: [RecycleSaleGuardService],
        component: RecycleDetailsComponent,
      },
    ]
  },
  {
    path: 'access-denied',
    component: ErrorComponent,
    data: {mode: 'access-denied'}
  },
  {
    path: '**',
    component: ErrorComponent,
    data: {mode: 'error'}
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
